/* Purpose: Styled text for the home page (for both guest and signed in users)
 * Props: 
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React from 'react';

const HomeInfo = () => {
    return (
        <div>
            <div className='m-3 mx-auto text-center home-container'>
                <h2><strong>Looking for an investment property loan?</strong></h2>
                <p>We offer 30 year fixed mortgages and 12 month bridge loans for residential 1 - 4 unit investment properties.</p>
                <p>No income verification or tax returns necessary.</p>
                <p>Quick closing.</p>
            </div>

            <hr width = "70%" className="border-bottom border-3 float-center mx-auto"></hr>
            <div className='m-3 mx-auto text-center home-container'>
                <h2><strong>What makes us different:</strong></h2>
                <p>Iska Mortgage was started by experienced real estate investors who understand investors' needs.</p>
                <p>We specialize in providing mortgage solutions optimized for 1 - 4 unit investment properties.</p>
                <p>Our streamlined system offers a hassle-free financing experience that is quick and straightforward.</p>
                <p>Choose Iska Mortgage for expert financing that sets us apart from traditional lenders.</p>
                <p>No income verification or tax returns necessary.</p>
                <p>Quick closing.</p>

            </div>
        </div>
    )
};

export default HomeInfo;